import React, { useRef, useState } from "react";
import { Modal } from "bootstrap";
import RECAPTCHA from "react-google-recaptcha";


import IconClose from '../../Assets/close-square.svg';
import { useNavigate } from "react-router-dom";

const JoinProgram = () => {
  const navigate = useNavigate();
  const [capVal, setCapVal] = useState(null);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    whatsAppNumber: "",
    isSameAsPhone: false,
  });
  const formRef = useRef<HTMLFormElement | undefined>(undefined);
  const [isSubmit, setIsSubmit] = useState<boolean>(false);


  // Handle input change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if ((name === "phoneNumber" || name === "whatsAppNumber") && !/^\d{0,10}$/.test(value)) {
      return; // Stop processing if input is invalid
    }

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });

    // If "Same as Phone Number" is checked, sync values
    if (name === "isSameAsPhone" && checked) {
      setFormData((prev) => ({
        ...prev,
        whatsAppNumber: prev.phoneNumber,
      }));
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmit(true);
    const payload = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      phoneNumber: formData.phoneNumber,
      whatsAppNumber: formData.whatsAppNumber,
      // challenges: 'Enquiry from Shero sparks'
    };


    console.log(' form dtaa ', new FormData(formRef.current));
    // const scriptURL = 'https://script.google.com/macros/s/AKfycbzbuuyurFsxAWGxMewhlrX0fajodB1fvAB4IUo73uO6Y1Ra2PCkUWJJNlhSf64-n1wF/exec'; // Replace with your Web App URL OLD durai sheet
    // const scriptURL = 'https://script.google.com/macros/s/AKfycbxGi4z21twK8dZzKg0trJ-LC1Cm6ll2bSu9vR_P9DAZq4RCm4B-gGT2HQNNzwlSKXlC/exec'; // Replace with your Web App URL
    // const scriptURL = 'https://script.google.com/macros/s/AKfycbx14OU8WkokIWf1cD1AtmnBwjAIzEZth9Vq8GnNhzjPLqtTVA-1H_iEffUKAZwoHY8JQg/exec';

    const scriptURL = 'https://script.google.com/macros/s/AKfycbx14OU8WkokIWf1cD1AtmnBwjAIzEZth9Vq8GnNhzjPLqtTVA-1H_iEffUKAZwoHY8JQg/exec'; // new sheet with column date
    // Add enquiry date to formData
    //pabbly script url 
    // const scriptURL = 'https://connect.pabbly.com/workflow/sendwebhookdata/IjU3NjMwNTY0MDYzMjA0MzU1MjY0NTUzNyI_3D_pc';
    try {
      let newDate = new Date()
      const response = await fetch(scriptURL, {
        method: 'POST',
        body: (`firstName=${formData.firstName}&lastName=${formData.lastName}&email=${formData.email}&phoneNumber=${formData.phoneNumber}&whatsAppNumber=${formData.whatsAppNumber}&newDate=${newDate}`),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }).then(res => res.text()).then(data => {
        console.log(data);
        const modalElement = document.getElementById("exampleModal");
        if (modalElement) {
          const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
          modalInstance.hide();

          document.body.classList.remove("modal-open");
          const backdrop = document.querySelector(".modal-backdrop");
          if (backdrop) {
            backdrop.remove();
          }
        }
        // Swal.fire({
        //   icon: "success",
        //   title: "Enquiry Submitted",
        //   text: "Thank you for registering!",
        //   confirmButtonText: "OK",
        // });
        navigate("/thankyou", { state: { status: "success", timestamp: Date.now() } })
        setIsSubmit(false);

        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phoneNumber: "",
          whatsAppNumber: "",
          isSameAsPhone: false,
        });

      }).catch(error => {
        console.log(' fetch derror ', error);
        const modalElement = document.getElementById("exampleModal");
        if (modalElement) {
          const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
          modalInstance.hide();

          document.body.classList.remove("modal-open");
          const backdrop = document.querySelector(".modal-backdrop");
          if (backdrop) {
            backdrop.remove();
          }
        }
        // Swal.fire({
        //   icon: "success",
        //   title: "Enquiry Submitted",
        //   text: "Thank you for registering!",
        //   confirmButtonText: "OK",
        // });
        navigate("/thankyou", { state: { status: "success", timestamp: Date.now() } })
        setIsSubmit(false);
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phoneNumber: "",
          whatsAppNumber: "",
          isSameAsPhone: false,
        });

      });

    } catch (error) {
      console.error('Error submitting form:', error);
      // alert('There was an error!');
    }
  };


  const isFormValid =
    formData.firstName.trim() &&
    formData.lastName.trim() &&
    formData.email.trim() &&
    formData.phoneNumber.trim().length === 10 && // Ensure exactly 10 digits
    formData.whatsAppNumber.trim().length === 10
    && capVal;

  return (
    <div
      className="modal fade"
      id="exampleModal"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-body">
            <img src={IconClose} alt='' className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close" />

            <h1 className="mb-4">Registration</h1>
            <form onSubmit={handleSubmit} ref={formRef}>
              <div className="mb-3">

                <input
                  type="text"
                  className="form-control"
                  id="firstName"
                  name="firstName"
                  placeholder="First name"
                  value={formData.firstName}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">

                <input
                  type="text"
                  className="form-control"
                  id="lastName"
                  name="lastName"
                  placeholder="Last name"
                  value={formData.lastName}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">

                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  placeholder="Email address"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">

                <input
                  type="tel"
                  className="form-control"
                  id="phoneNumber"
                  name="phoneNumber"
                  placeholder="Phone number"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  pattern="\d{10}" // HTML5 validation
                // maxLength="10" // Ensure only 10 characters
                />
              </div>
              <div className="mb-3">

                <input
                  type="tel"
                  className="form-control"
                  id="whatsAppNumber"
                  name="whatsAppNumber"
                  placeholder="WhatsApp number"
                  value={formData.whatsAppNumber}
                  onChange={handleChange}
                  pattern="\d{10}" // HTML5 validation
                // maxLength="10" // Ensure only 10 characters
                />
              </div>
              <div className="form-check mb-4 d-flex justify-content-end">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="isSameAsPhone"
                  name="isSameAsPhone"
                  checked={formData.isSameAsPhone}
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="isSameAsPhone">
                  Same as your phone number
                </label>
              </div>
              <RECAPTCHA sitekey="6Ld5kqUqAAAAAGh-h4BG1oRpGG-sFUpmRYjzGHtX"
                onChange={(value) => setCapVal(value)}
              />
              <button type="submit" className="m-auto btn btn-primary w-100 py-2 mt-5" disabled={!isFormValid || isSubmit}>
                Join our program
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinProgram;
